import React from 'react';
import { Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Register from './containers/Register';
import ConnectThridPartyAccount from './containers/ConnectThridPartyAccount';
import ConnectPhone from './containers/ConncetPhone';
import PublicRoute from '../PublicRoute';
import Mgm from './containers/Mgm';
import config from '../preorder/configs/config';

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundImage: `url("${config.RESOURCE_URI}registering/mobile_LoginBG.png")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url("${config.RESOURCE_URI}registering/website_login_bg.jpg")`,
    },
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <Box
      className={classes.background}
      display="flex"
      justifyContent="center"
      alignItems="stretch"
      height="100%"
    >
      <Box
        display="flex"
        justifyContent="center"
        width={{
          xs: 1,
          sm: 768,
          md: 876,
          lg: 1080,
          xl: 1340,
        }}
      >
        <Switch>
          <PublicRoute path="/register/connect-third-party-account" component={ConnectThridPartyAccount} />
          <PublicRoute path="/register/connect-phone" component={ConnectPhone} />
          <PublicRoute path="/register/mgm" component={Mgm} />
          <PublicRoute path="/register" component={Register} />
        </Switch>
      </Box>
    </Box>
  );
};
